import React, { Fragment } from "react";
import flatten from "lodash/flatten";
import chunk from "lodash/chunk";
import { Link } from "@quintype/components";
import { PublishAndReadTime } from "../../../atoms/PublishAndReadTime";
import { replaceWithAlternates } from "../../../utils";
import { ImageThumbnail } from "../ImageThumbnail";
import "./related-stories.m.css";

export default function RelatedStories({ extraPadding = false, relatedStories = [] }) {
  const newList = relatedStories.map((item) => item.story);
  return (
    newList?.length > 0 && (
      <div styleName={`related-stories-wrapper ${extraPadding ? "extra-padding" : ""}`}>
        <p styleName="title"> Related Stories</p>
        <div styleName="wrapper">
          {flatten(
            chunk(newList, 2).map((storyGroup, index) => (
              <Fragment key={index}>
                <div styleName="story-row">
                  {storyGroup.map((story, index) => {
                    const alternateStory = replaceWithAlternates(story);
                    return (
                      <Fragment key={index}>
                        <Link key={index} href={`/${story?.slug}`}>
                          <div styleName="card">
                            <figure styleName="image-container" style={{ "--aspect-ratio": 4 / 3 }}>
                              <ImageThumbnail story={alternateStory} />
                            </figure>
                            <div styleName="card-details">
                              <p styleName="headline">{alternateStory?.headline}</p>
                              <PublishAndReadTime story={story} showReadTime={true} showTimestamp={true} />
                            </div>
                          </div>
                        </Link>
                        {index !== storyGroup.length - 1 && <div styleName="divider"></div>}
                      </Fragment>
                    );
                  })}
                </div>
                <div styleName="row-divider"></div>
              </Fragment>
            ))
          )}
        </div>
      </div>
    )
  );
}
